import React from "react";
import { Route, Routes } from "react-router-dom";

import { PROTECTED_ROUTES } from "./site-map";
import { VisionAI } from "../../containers";

import StudentDashboardLayout from "../../components/layouts/student-dashboard-layout";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<StudentDashboardLayout />}>
        {PROTECTED_ROUTES.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.component}
            exact={route.exact}
          />
        ))}
      </Route>

      <Route
        key={12321}
        path={"/vision-ai"}
        element={<VisionAI />}
        exact={false}
      />
    </Routes>
  );
};

export default AppRoutes;
